import { type RouteObject } from 'react-router';
import { SelfCheckAssistantShell } from '../../components/assistant/self-check-assistant-shell';
import { RoutesList } from '../../config/routes-list';
import { type LazyRouteConfig, lazyRoute, lazyRouteNamed } from '../lazy-route';

function createSelfCheckRoutes(
  basePath: string,
  recordRoute: LazyRouteConfig,
  calendarRoute: LazyRouteConfig,
  exportPdfRoute: LazyRouteConfig,
): RouteObject {
  return {
    path: basePath,
    element: <SelfCheckAssistantShell />,
    children: [
      { index: true, ...recordRoute },
      { path: 'summary', ...calendarRoute },
      // Modale "Registrazioni del giorno": stessa pagina con la dialog
      // routata sopra (convenzione useRouteDialog, vedi useDayRecordsDialog).
      { path: 'summary/day/:date', ...calendarRoute },
      { path: 'record', ...recordRoute },
      { path: 'export-pdf', ...exportPdfRoute },
    ],
  };
}

export const selfCheckRoutes: RouteObject[] = [
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_TEMPERATURE,
    lazyRouteNamed(
      () => import('../../pages/self-check/temperature/record-page/record-page'),
      'TemperatureRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/temperature/main-page')),
    lazyRouteNamed(
      () => import('../../pages/self-check/temperature/export-pdf-page'),
      'TemperatureExportPdfPage',
    ),
  ),
  {
    path: '/self-check/temperature/equipment/:equipmentId/history',
    element: <SelfCheckAssistantShell />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () =>
            import(
              '../../pages/self-check/temperature/equipment-history-page/equipment-history-page'
            ),
          'EquipmentHistoryPage',
        ),
      },
    ],
  },
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_METAL_DETECTION,
    lazyRouteNamed(
      () => import('../../pages/self-check/metal-detection/record-page/record-page'),
      'MetalDetectionRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/metal-detection/main-page')),
    lazyRouteNamed(
      () => import('../../pages/self-check/metal-detection/export-pdf-page'),
      'MetalDetectionExportPdfPage',
    ),
  ),
  {
    path: RoutesList.SELF_CHECK_METAL_DETECTION_DETECTOR_HISTORY,
    element: <SelfCheckAssistantShell />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () =>
            import(
              '../../pages/self-check/metal-detection/detector-history-page/detector-history-page'
            ),
          'DetectorHistoryPage',
        ),
      },
    ],
  },
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_OIL_CHANGE,
    lazyRouteNamed(
      () => import('../../pages/self-check/oil-change/record-page/record-page'),
      'OilRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/oil-change/main-page')),
    lazyRoute(() => import('../../pages/self-check/oil-change/export-pdf-page')),
  ),
  {
    path: '/self-check/oil-change/fryer/:fryerId/history',
    element: <SelfCheckAssistantShell />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/self-check/oil-change/fryer-history-page/fryer-history-page'),
          'FryerHistoryPage',
        ),
      },
    ],
  },
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_CLEANING,
    lazyRouteNamed(
      () => import('../../pages/self-check/cleaning/record-page/record-page'),
      'CleaningRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/cleaning/main-page')),
    lazyRoute(() => import('../../pages/self-check/cleaning/export-pdf-page')),
  ),
  {
    path: '/self-check/cleaning/area/:areaId/history',
    element: <SelfCheckAssistantShell />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/self-check/cleaning/area-history-page/area-history-page'),
          'AreaHistoryPage',
        ),
      },
    ],
  },
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_PEST_CONTROL,
    lazyRouteNamed(
      () => import('../../pages/self-check/pest-control/record-page/record-page'),
      'PestControlRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/pest-control/main-page')),
    lazyRouteNamed(
      () => import('../../pages/self-check/pest-control/export-pdf-page'),
      'PestControlExportPdfPage',
    ),
  ),
  {
    path: '/self-check/pest-control/point/:pointId/history',
    element: <SelfCheckAssistantShell />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/self-check/pest-control/point-history-page/point-history-page'),
          'PointHistoryPage',
        ),
      },
    ],
  },
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_BLAST_CHILLING,
    lazyRouteNamed(
      () => import('../../pages/self-check/blast-chilling/record-page/record-page'),
      'BlastChillingRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/blast-chilling/main-page')),
    lazyRouteNamed(
      () => import('../../pages/self-check/blast-chilling/export-pdf-page/export-pdf-page'),
      'BlastChillingExportPdfPage',
    ),
  ),
  createSelfCheckRoutes(
    RoutesList.SELF_CHECK_COOKING_TEMPERATURE,
    lazyRouteNamed(
      () => import('../../pages/self-check/cooking-temperature/record-page/record-page'),
      'CookingTemperatureRecordPage',
    ),
    lazyRoute(() => import('../../pages/self-check/cooking-temperature/main-page')),
    lazyRouteNamed(
      () => import('../../pages/self-check/cooking-temperature/export-pdf-page/export-pdf-page'),
      'CookingTemperatureExportPdfPage',
    ),
  ),
];
